module.exports = __webpack_public_path__ + "img/logo.31200fe1.webp";